
import { defineComponent, PropType } from 'vue'

// module components
import CompletedCargo from '@/modules/CreateOrderModule/components/CompletedCargo/index.vue'

// types
import { CompletedCargoT } from '@/core/types/create_order.types'
import { AdditionalServicesI } from '@/core/types/additional_services.types'
import { AdditionalByIdT } from '@/core/types/billing.types'

export default defineComponent({
    components: {
        'completed-cargo': CompletedCargo,
    },
    props: {
        cargos: {
            type: Array as PropType<CompletedCargoT[]>,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        additionalServices: {
            type: Array as PropType<AdditionalByIdT[]>,
            default: () => [],
        },
        isBosch: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['delete-cargo', 'update-cargo', 'update-additional-services'],
    setup(props, { emit }) {
        const emitDeleteCargo = (index: number) => {
            emit('delete-cargo', index)
        }

        const emitUpdateCargo = (index: number) => {
            emit('update-cargo', index)
        }

        const emitUpdateAdditionalServices = (payload: {
            index: number
            additional_services: AdditionalServicesI
        }) => {
            emit('update-additional-services', payload)
        }

        return { emitDeleteCargo, emitUpdateCargo, emitUpdateAdditionalServices }
    },
})
